


import { createSlice } from "@reduxjs/toolkit";

const initialState = {
//   selectedNoteType: "",
  loading: false,
  addbillingconsumerLoading: false,
  addbillinginvoicesLoading:false,
//   loadingNote_Types: false,

allbillinginvoicesConsumer: [],
allbillinginvoices: [],
allbillingRecurringinvoices: [],
allPaidInvoices:[],
CashandChequeInvoice:[],
//   noteTypes: [],
//   allNotesTypes: [],
//   fieldType: [],
//   notesAgainstTypes: []
};

export const billinginvoiceState = createSlice({
  name: "billinginvoiceReducer",
  initialState,
  reducers: {
    setLoading(state, action) {
      return {
        ...state,
        loading: action?.payload
      };
    },

    setAddBillingConsumerLoading(state, action) {
      return {
        ...state,
        addbillingconsumerLoading: action?.payload
      };
    },

    setAddBillingInvoicesLoading(state, action) {
        return {
          ...state,
          addbillinginvoicesLoading: action?.payload
        };
      },

    setAllBillinginvoicesConsumers(state, action) {
        return {
          ...state,
          loading: false,
          allbillinginvoicesConsumer: action?.payload,
        //   addFacilityLoading: false
        };
      },



      

      setAllBillinginvoices(state, action) {
        return {
          ...state,
          loading: false,
          allbillinginvoices: action?.payload,
        //   addFacilityLoading: false
        };
      },


      setAllBillingRecurringinvoices(state, action) {
        return {
          ...state,
          loading: false,
          allbillingRecurringinvoices: action?.payload,
        //   addFacilityLoading: false
        };
      },


      setAllBillingPaidinvoices(state, action) {
        return {
          ...state,
          loading: false,
          allPaidInvoices: action?.payload,
        //   addFacilityLoading: false
        };
      },

      
      setAllCashChequeInvoices(state, action) {
        return {
          ...state,
          loading: false,
          CashandChequeInvoice: action?.payload,
     
        };
      },



      




    // Reset State
    reset() {
      return initialState;
    }
  }
});

export const {
  setLoading,
  setAddBillingConsumerLoading,
  setAllBillinginvoicesConsumers,
  setAddBillingInvoicesLoading,
  setAllBillinginvoices,
  setAllBillingRecurringinvoices,
  setAllBillingPaidinvoices,
  setAllCashChequeInvoices,
 
} = billinginvoiceState.actions;
export default billinginvoiceState.reducer;
